import { WeaTools } from 'ecCom';
export const url = '/api/cube/tree'
export const initTree = (params) => {
    return WeaTools.callApi(`${url}/init`, "get", params);
}
export const getTreeDatas = (params) => {
    return WeaTools.callApi(`${url}/datas`, "get", params);
}
export const getTreeHref = (params) => {
    return WeaTools.callApi(`${url}/href`, "get", params);
}
export const quickSearch = (params) => {
    return WeaTools.callApi(`${url}/quickSearch`, "get", params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/tree.ts